/**
 * Form layout constants shared across admin-portal forms.
 *
 * A dropdown is sized to its options, never to the page: a full-width Select
 * stretches a one-word choice across the viewport and reads as broken. It
 * still shrinks on narrow screens because width is 100% up to the cap.
 */
export const DROPDOWN_MAX_WIDTH_PX = 480;

/** Spread onto the FormControl wrapping a Select, instead of `fullWidth`. */
export const DROPDOWN_SX = { width: '100%', maxWidth: DROPDOWN_MAX_WIDTH_PX } as const;

/** A short enum filter (status, type, difficulty, role, severity). */
export const DROPDOWN_NARROW_WIDTH_PX = 160;
/** A person, track or other long-name picker. */
export const DROPDOWN_WIDE_WIDTH_PX = 240;
/** The search box in a filter row (Users). */
export const FILTER_SEARCH_WIDTH_PX = 280;

/**
 * Filter-row text: --text-body-s (14px), the size of the tabs beside it. Set on
 * the input only; the floating label keeps MUI's size so it stays legible.
 */
export const FILTER_TEXT_SX = { '& .MuiInputBase-root': { fontSize: 'var(--text-body-s)' } } as const;

/**
 * Filter-row widths are fixed: picking a longer value never moves the row (a
 * long name ends in an ellipsis; the open menu shows it in full).
 */
export const DROPDOWN_NARROW_SX = { width: DROPDOWN_NARROW_WIDTH_PX, ...FILTER_TEXT_SX } as const;
export const DROPDOWN_WIDE_SX = { width: DROPDOWN_WIDE_WIDTH_PX, ...FILTER_TEXT_SX } as const;
